<template>
  <div id="container">
    <div class="margin-tb-20 text-center">
      <img :src="'https://api.tbxprint.com/tool/code/barcode?code='+model.code" width="75%" />
    </div>
    <van-cell-group>
      <van-cell title="订单号" :value='model.code'/>
      <van-cell title="创建时间" :value='model.create_time'/>
      <van-cell title="提货码" :value='model.datas.code'/>
    </van-cell-group>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    this.reload()
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
    reload () {
      Api.post('wor.request/model', {id: this.$route.query.id}, res => {
        this.model = res.data
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Request.vue